import React from 'react';
import Container from './Container';
import Text from './Text';
import Logo from './Logo';
import Date from './Date';
import Verified from './Verified';

export default ({ bank_account }) => (
  <Container>
    <Logo logo_type={bank_account.logo_type} logo={bank_account.logo_src} />
    <Text>{bank_account.bank_account}</Text>
    <Date>{bank_account.updated_at}</Date>
    <Verified verified={bank_account.is_verified} />
  </Container>
);
